import { SortDescriptor } from '@progress/kendo-data-query'
import { AccountGroupFilterKey, AccountGroupKey } from 'api/Trading-Accounts/Types/AccountGroupDto'

export const normalizeAccountGroupsSortQuery = (
  sortDescriptors: SortDescriptor[]
): SortDescriptor[] =>
  sortDescriptors
    .map((x) => {
      if (x.field === AccountGroupKey.NAME) {
        return { ...x, field: AccountGroupFilterKey.NAME }
      }
      if (x.field === AccountGroupKey.TRADING_ACCOUNT_TYPE) {
        return { ...x, field: AccountGroupFilterKey.TRADING_ACCOUNT_TYPE }
      }
      if (x.field === AccountGroupKey.PLATFORM_TYPE) {
        return { ...x, field: AccountGroupFilterKey.PLATFORM }
      }
      if (x.field === AccountGroupKey.ACCOUNT_GROUP_TYPE) {
        return { ...x, field: AccountGroupFilterKey.ACCOUNT_GROUP_TYPE }
      }
      if (x.field === AccountGroupKey.BOOK_TYPE) {
        return { ...x, field: AccountGroupFilterKey.BOOK_TYPE }
      }
      if (x.field === AccountGroupKey.CLASSIFICATION_TYPE) {
        return { ...x, field: AccountGroupFilterKey.CLASSIFICATION_TYPE }
      }
      if (x.field === AccountGroupKey.CURRENCY) {
        return { ...x, field: AccountGroupFilterKey.CURRENCY }
      }
      if (x.field === AccountGroupKey.COUNTRY) {
        return { ...x, field: AccountGroupFilterKey.COUNTRY }
      }
      if (x.field === AccountGroupKey.IS_ENABLED) {
        return { ...x, field: AccountGroupFilterKey.IS_ENABLED }
      }
      if (x.field === AccountGroupKey.IS_SWAP_FREE) {
        return { ...x, field: AccountGroupFilterKey.IS_SWAP_FREE }
      }
      if (x.field === AccountGroupKey.SERVERS) {
        return { ...x, field: AccountGroupFilterKey.SERVERS }
      }
      return x
    })
    .filter((x) => !!x)
